<template>
  <h4>
    <slot />
  </h4>
</template>

<script>
export default {
  props: {},
};
</script>

<style scoped>
h4 {
  margin-top: 0;
  margin-bottom: 0;

  color: var(--gray-800);

  font-size: 26px;
  font-family: var(--font-family-sans);
  font-weight: 600;
  line-height: 34px;
  text-align: left !important; /* NOTE @chris Global leak. */
}
</style>
